import { memo, useEffect, useRef } from 'react';
import { withRouter } from '~HOC';

const usePreviousValue = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const ScrollToTop = memo((props) => {
  const prevCount = usePreviousValue(props.pathname);
  props.pathname !== prevCount &&
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  return props.children;
});

export default withRouter(ScrollToTop);
